//#region src/util/EventEmitter.ts
var e = class {
	callbacks = {};
	on(e, t) {
		return this.callbacks[e] || (this.callbacks[e] = []), this.callbacks[e].push(t), () => this.off(e, t);
	}
	emit(e, ...t) {
		let n = this.callbacks[e];
		n && n.forEach((e) => e.apply(this, t));
	}
	off(e, t) {
		let n = this.callbacks[e];
		n && (t ? this.callbacks[e] = n.filter((e) => e !== t) : delete this.callbacks[e]);
	}
	removeAllListeners() {
		this.callbacks = {};
	}
};
//#endregion
export { e as t };

//# sourceMappingURL=EventEmitter-CuPnGDYt.js.map